// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'jquery';
import 'popper.js';
import 'bootstrap';
import './assets/js/tooltip.js';
// import './assets/plugins/sidemenu/sidemenu-1/sidemenu-1.js';
// import './assets/plugins/sidemenu-responsive-tabs/js/sidemenu-responsive-tabs.js';
// import './assets/plugins/sidebar/sidebar.js';
import './assets/js/jquery.showmore.js';
import './assets/js/scripts1.js';

import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js